import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IGst, IGstCriteria } from '../gst.interface';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-gst-list',
    templateUrl: './gst-list.component.html',
    styleUrls: ['./gst-list.component.less'],
    standalone: false
})
export class GstListComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private formBuilder:FormBuilder,
    private utilityService:UtilityService,
    private service:DataService,private logger:NGXLogger,
    private router:Router,private activatedRoute:ActivatedRoute,
    private permissionService:PermissionService){}

gstForm:FormGroup;
gstColumns=['code','name','description','type','action'];
@ViewChild(MatPaginator) paginator: MatPaginator;
totalSectorRecords:number;
@ViewChild(MatSort) sort: MatSort;
gstList = new MatTableDataSource<IGst>();
criteria: IGstCriteria = {};
pageSizeOptions:Array<number>=this.utilityService.getPageSizeOptions();
gstTypes=[];
addPermission:boolean=false;
viewPermission:boolean=false;
editPermission:boolean=false;
subscription = new Subscription();

ngOnInit(){
  this.getAllPermissions();
  this.initializeForm();
  this.setCodeValueChangeEvent();
  this.setNameValueChangeEvent();
  this.setTypeValueChangeEvent();
  this.getGstTypes();
}

ngOnDestroy(): void {
  this.subscription.unsubscribe();
}

initializeForm(){
  this.gstForm=this.formBuilder.group({
    id:[],
    code:[],
    name:[],
    type:[]
  });
}

setCodeValueChangeEvent(){
  this.subscription = this.code.valueChanges.subscribe(codeValue => {
    this.criteria['code.contains']=codeValue;
    this.getGstList(true);
  })
}

setNameValueChangeEvent(){
  const sub = this.name.valueChanges.subscribe(nameValue => {
    this.criteria['name.contains']=nameValue;
    this.getGstList(true);
  });
  this.subscription.add(sub);
}

setTypeValueChangeEvent(){
  const sub = this.type.valueChanges.subscribe(typeValue => {
    this.criteria.type=typeValue;
    this.getGstList(true);
  });
  this.subscription.add(sub);
}

ngAfterViewInit(){
  this.criteria.page=0;
  this.criteria.size=20;
  this.gstList.paginator = this.paginator;
  this.gstList.sort = this.sort;
  this.paginator.page.pipe(tap(() => this.getGstList())).subscribe();
  this.getGstList();
}

sortData(event){
  this.criteria.sort = [event.active, event.direction];
  this.getGstList(true);
}

openGstForm(id?:any){
  if(id){
    this.editPermission ? this.router.navigate(['edit/'+id],{relativeTo:this.activatedRoute}) : 
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
  } else {
    this.addPermission ? this.router.navigate(['add'],{relativeTo:this.activatedRoute}) :
        this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
  }
}

getGstList(resetPageIndex: boolean =false){
  if (resetPageIndex) {
    this.paginator.pageIndex = 0;
  }
  this.criteria.page=this.paginator.pageIndex;
  this.criteria.size=this.paginator.pageSize;
  if(this.viewPermission){
    this.service.get(Api.GST, this.criteria).subscribe(res => { 
      if(res){
        this.logger.info('gst res', res);
        this.gstList=res.contents;
        this.totalSectorRecords=res.totalRecords;
        if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
          this.paginator.pageIndex = 0;
        }
      }
    });
  } else
      this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
}

getGstTypes(){
  this.service.get(Api.GST_TYPES).subscribe(res => { 
    this.gstTypes.push({key: "", label: "Search by Gst Type"});
    this.gstTypes.push(...res);
  });
}

private getAllPermissions(){
  const permissionCodes=[PermissionKey.GST_ADD_PERMISSION,PermissionKey.GST_VIEW_PERMISSION,PermissionKey.GST_EDIT_PERMISSION];
  const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.GST);
  this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.GST_ADD_PERMISSION})?.show?true:false;
  this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.GST_VIEW_PERMISSION})?.show?true:false;
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.GST_EDIT_PERMISSION})?.show?true:false;
}

get code(){return this.gstForm.get('code'); }
get name(){return this.gstForm.get('name'); }
get type(){return this.gstForm.get('type'); }

}
